import { useState } from "react";
import { Layout } from "../../components/Layout";
import comingsoonImg from "../../comingsoon.png";

function Availability({ onNavigate }) {
  return (
    <Layout title="Availability" onNavigate={onNavigate}>
      <div className="flex flex-col items-center justify-center h-full p-4 text-center">
        <h3 className="font-semibold text-lg mb-3">Availability</h3>
        <img
          src={comingsoonImg}
          alt="TechDispatch Logo"
          className="w-20 mb-3"
        />
        <h4 className="font-semibold ">Coming Soon</h4>
      </div>
    </Layout>
  );
}
export default Availability;
